<template>
  <modal :show.sync="showModal">
    <h6 slot="header" class="modal-title">Crear Sponsor</h6>
    <form class="needs-validation" id="formCreateSponsor"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="model.name">
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <base-input
            label="País"
            name="pais"
            placeholder=""
            :error="getError('pais')"
            v-validate="'required'"
            v-model="model.pais"
          >
            <el-select clearable v-model="model.pais" filterable
                        placeholder="Seleccione país">
                <el-option v-for="option in selectPaises"
                            :key="option.label"
                            :label="option.label"
                            :value="option.value">
                </el-option>
            </el-select>
          </base-input>
        </div>
      </div>
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formCreateSponsor">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
  import { Select, Option } from 'element-ui';
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        validated: false,
        model: {
          name: '',
          pais: undefined,
        },
        showModal: false,
        selectPaises: [
          { label: 'Chile', value: 'Chile' },
          { label: 'Perú', value: 'Perú' },
          { label: 'Colombia', value: 'Colombia' },
          { label: 'Ecuador', value: 'Ecuador' },
          { label: 'Costa Rica', value: 'Costa Rica' },  
          { label: 'Argentina', value: 'Argentina' },

        ]
      }
    },
    methods: {
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(){
        var vm = this;
        
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          if( response ){
            
            vm.axios({
                method: 'POST',
                url: 'api/store_create_sponsor',
                data: {   
                        nombre: vm.model.name,
                        pais: vm.model.pais, 
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Sponsor creado exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo almacenar el sponsor',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
        }).catch( reason => {
          console.log(reason);
        });
        
      },
    },
    created()
    {
      this.$parent.$on('showModalCreateSponsor', () => { this.showModal = true; } )
    }
  }
</script>
<style>
</style>
